<template>
  <router-view />
</template>

<script>
import { unRegisterMixin } from '@/mixin/storeGenerator';

export default {
  name: 'WrapperReorganizeDashboard',
  mixins: [unRegisterMixin],
  data() {
    return {
      moduleName: 'reorganizeDashboardModule',
    };
  },
};
</script>
